import Intro from "../../components/blocks/Intro/Intro";
import { translate } from "../../localization";

const Error = () => {
  const i18n = translate();

  return <Intro headline={i18n.error.headline} text={i18n.error.text} />;
};

export default Error;
